/* eslint-disable */
import getValidParams from './getValidParams';
import defaultInitialValues from './defaultInitialValues';

import omitBy from 'lodash/omitBy';

import addDays from 'date-fns/addDays';
import startOfDay from 'date-fns/startOfDay';
import isValidDate from 'date-fns/isValid';

/** '25.10.2020' -> Date */
const parseDottedDate = (dateStr) => {
  if (dateStr) {
    const dateISO = dateStr.split('.').reverse().join('-');
    const date = new Date(dateISO);

    if (isValidDate(date)) {
      return date;
    }
  }
};

const parseQueryParams = (query) => {
  const {
    adults,
    kids_ages,
    start_date,
    nights,
    from_city,
    to_country,
    to_city,
    to_region,
    flex_nights,
    destination_query,
  } = query;

  const toCountry = to_country && (to_country.length === 2 ? to_country : Number(to_country)); // iso || id,
  const destination = Number(to_city || to_region) || toCountry;

  const params = {
    adults: adults && Number(adults),
    departure: from_city && Number(from_city),
    flexNights: Boolean(flex_nights),
    nights: nights && Number(nights),
  };

  if (destination && destination_query) {
    Object.assign(params, {
      destination,
      destinationQuery: decodeURI(destination_query),
    });
  }

  if (start_date) {
    const startDate = startOfDay(parseDottedDate(start_date));
    Object.assign(params, {
      dates: {
        startDate,
        endDate: addDays(startDate, nights),
      },
    });
  }

  if (kids_ages) {
    Object.assign(params, {
      childrenAges: kids_ages.split(',').slice(0, 3),
    });
  }

  return omitBy(params, (param) => param === undefined);
};

export default function getValuesFromQuery(query, { minDate, maxDate } = {}) {
  const parsedValues = parseQueryParams(query);
  const validValues = getValidParams(parsedValues, { minDate, maxDate });

  return {
    ...defaultInitialValues,
    ...validValues,
  };
}
